import { emitter } from '@marvelapp/react-ab-test';

export const SERIES_TYPE = 'series';
export const COURSES_TYPE = 'courses';
export const PRACTICES_TYPE = 'practices';

/**
 * This function receives the hoveredType and the arrays of available series,
 * courses and practices and returns the first item with menuHighlight of the
 * hoveredType or the first item with menuHighlight of any type if hoveredType
 * is null
 */
export const getFeaturedItem = (hoveredType, series, courses, practices) => {
  // Check if B-WithFeatured variant is active, if not return null
  if (emitter.getActiveVariant('learning-lab-popover') !== 'B-WithFeatured')
    return [null, null];

  // Validate array inputs
  if (
    !Array.isArray(series) ||
    !Array.isArray(courses) ||
    !Array.isArray(practices)
  ) {
    console.error('getFeaturedItem: Invalid input arrays');
    return [null, null];
  }

  // If user didn't hover any type, return the first item with menuHighlight following the order: series, courses, practices
  if (!hoveredType) {
    let featuredItem = series.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, SERIES_TYPE];

    featuredItem = courses.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, COURSES_TYPE];

    featuredItem = practices.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, PRACTICES_TYPE];

    return [null, null];
  }

  // If user hovered a type, return the first item with menuHighlight of that type
  if (hoveredType === SERIES_TYPE) {
    const featuredItem = series.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, SERIES_TYPE];
  }

  if (hoveredType === COURSES_TYPE) {
    const featuredItem = courses.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, COURSES_TYPE];
  }

  if (hoveredType === PRACTICES_TYPE) {
    const featuredItem = practices.find(item => item.fields.menuHighlight);
    if (featuredItem) return [featuredItem, PRACTICES_TYPE];
  }

  // If hoveredType is invalid, return null
  console.error('getFeaturedItem: Invalid hoveredType');
  return [null, null];
};
